import React from 'react';

const BookCardPlaceholder = () => (
  <div className="book-card">
    <div className="book-card-content">
      <div className="mid-top" />

      <div className="mid-bottom">
        <div className="animated-background" />
        <div className="animated-background" style={{ marginTop: '12px' }} />
        <div className="animated-background" style={{ marginTop: '40px', width: '50%' }} />
      </div>
    </div>
  </div>
);

export default BookCardPlaceholder;
